import Header from "../Components/Header";
import InfoBodyApple from "../Components/InfoBodyApple";


const InfoApple = () => {
    return (
        <div className='h-screen w-full'>
            <Header />
            <InfoBodyApple/>
        </div>
    )
}

export default InfoApple;